module.exports = __webpack_public_path__ + "img/games.08794909.gif";